import Model, { hasMany, type AsyncHasMany } from '@ember-data/model';
import type GoalModel from './goal';
import type MetricModel from './metric';

// The polymorphic base of department, person and team. It has no [Type] brand
// of its own, so each subclass can brand itself.
export default class OwnerModel extends Model {
  @hasMany('goal', { async: true, inverse: 'owner', as: 'owner' })
  declare goals: AsyncHasMany<GoalModel>;
  @hasMany('metric', { async: true, inverse: 'owner' })
  declare metrics: AsyncHasMany<MetricModel>;
}
